// extracted by mini-css-extract-plugin
var _1 = "MentionBase-module__animateUploadProgressBarWidth--Kl0oc";
var _2 = "MentionBase-module__animatedBackground--M7Cpt";
var _3 = "MentionBase-module__closed--_f1gJ";
var _4 = "MentionBase-module__container--TZ0O4";
var _5 = "MentionBase-module__group--PqFfE";
var _6 = "MentionBase-module__icon--kOMaN";
var _7 = "MentionBase-module__innerHead--dbaeX";
var _8 = "MentionBase-module__innerTail--HCdRv";
var _9 = "MentionBase-module__post--s38WI";
var _a = "MentionBase-module__topic--MDOFh";
var _b = "MentionBase-module__user--u1PeB";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "closed", _4 as "container", _5 as "group", _6 as "icon", _7 as "innerHead", _8 as "innerTail", _9 as "post", _a as "topic", _b as "user" }
